import Vue from 'vue'
import Router from 'vue-router'
import Start from '@/templates/views/Start'
import Thanks from '@/templates/views/Thanks'
import Helpdesk from '@/templates/views/Helpdesk'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'Start',
      component: Start
    },
    {
      path: '/thanks',
      name: 'Thanks',
      component: Thanks
    },
    {
      path: '/helpdesk',
      name: 'Helpdesk',
      component: Helpdesk
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js